import { requestService } from 'shared/utils/services/requestService';

export async function logOutUser() {
  return requestService({
    url: '/web-api/v1/logout',
    method: 'post',
  });
}
